import * as styleConstants from "@affinity/constants/StyleConstants";
import * as styleHelpers from "@affinity/constants/StyleHelpers";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import styled from "styled-components";

export const HorizontalLine = styled.hr`
    background-color: ${styleConstants.colours.darkGrey};
    height: ${styleHelpers.rem(2)};
    margin: ${styleHelpers.rem(10)} 0;
`;

const widgetModule: WidgetModule = {
    component: HorizontalLine,
    definition: {
        group: "Basic",
        icon: "minus",
    },
};

export default widgetModule;